import DefaultLayout from "../components/layout/DefaultLayout";
import ListProperties from "../components/properties/ListProperties";

function RentProperties() {
  const body = () => {
    return <ListProperties bussines="rent" />;
  };
  return (
    <div>
      <div>
        <DefaultLayout body={body()} />
      </div>
    </div>
  );
}

export default RentProperties;
